<template>
  <div style="padding: 20px">
    <el-form label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="领料申请编号">
            <el-input v-model="request_id" class="form-item" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编码">
            <el-input v-model="material_code" class="form-item" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="待回料数量">
            <el-input v-model="wait_return_cnt" class="form-item" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">

        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="退料个人库">
            <el-select v-model="formData.from_store_id" class="form-item" placeholder="退料个人库" clearable>
              <el-option v-for="item in myStoreList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="退回目的总库">
            <el-select v-model="formData.to_store_id" class="form-item" placeholder="退回目的总库" clearable>
              <el-option v-for="item in storeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="回料SN" v-if="parentData.send_type==='by_sn'">
            <el-input v-model="formData.return_sn" class="form-item"></el-input>
          </el-form-item>
          <el-form-item label="回料数量" v-else>
            <el-input-number v-model="formData.return_cnt" class="form-item" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="formData.remark" class="form-item"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="">
        <el-button @click="createRequest" :loading="loading">提交</el-button>
        <KfMessage ref="commitMessage"/>
      </el-form-item>


    </el-form>

  </div>
</template>

<script>
export default {
  name: "CreateReturnRequestNew",
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      material_code: this.parentData.material_code,
      request_id: this.parentData.request_id,
      wait_return_cnt: this.parentData.wait_return_cnt,
      formData: {
        request_item_id: this.parentData.id,
        from_store_id: '',
        to_store_id: '',
        return_sn: '',
        return_cnt: '',
        remark: ''
      },
      storeList: [],
      myStoreList: [],
      loading: false
    }
  },
  created() {
    console.log(this)
    this.getStoreList()
    this.getMyStoreList()
  },
  methods: {
    getStoreList() {
      this.$axios.get('wms/store/getStoreList?personal=false&sameCity=true').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取仓库列表失败");
        }

        this.storeList = res.data || [];
        this.storeList.forEach(item => {
          if (item.store_type == 'store_waste') {
            this.formData.to_store_id = item.id
          }
        })
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    getMyStoreList() {
      this.$axios.get('wms/store/getMyStoreList').then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取仓库列表失败");
        }

        this.myStoreList = res.data || [];

        this.myStoreList.forEach(item => {
          if (item.store_type == 'store_waste') {
            this.formData.from_store_id = item.id
          }
        })
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    createRequest() {
      if (this.formData.from_store_id == '') {
        return this.$refs.commitMessage.showError("未选择个人库");
      }
      if (this.formData.to_store_id == '') {
        return this.$refs.commitMessage.showError("未选择总库");
      }
      if (this.parentData.send_type === 'by_sn') {
        if (this.formData.return_sn == '') {
          return this.$refs.commitMessage.showError("未输入回料SN");
        }
        this.formData.return_cnt = 1;
      } else {
        if (this.formData.return_cnt == '') {
          return this.$refs.commitMessage.showError("未输入回料数量");
        }
      }
      if (this.formData.return_cnt > this.wait_return_cnt) {
        return this.$refs.commitMessage.showError("回料数量不能大于待回料数量");
      }

      this.loading = true
      this.$refs.commitMessage.clear()
      this.$http('wmsReturnRequestService.createRequest', this.formData, false).then(async data => {
        this.loading = false
        let msg = '提交成功';
        if (data > 0) {
          msg += '，剩余待回料数量为【' + data + '】';
        } else {
          msg += '，该申请单已完成回料';
        }
        this.$refs.commitMessage.showSuccess(msg)
        this.wait_return_cnt = data

        this.formData.return_sn = ''
        this.formData.return_cnt = ''
        this.$fn.search();
      }, errMsg => {
        this.loading = false
        this.$refs.commitMessage.showError(errMsg)
      })

    }
  }
}
</script>

<style scoped>
.form-item {
  width: 200px;
}
</style>